const root = "_35sru8g17l";
const scroller = "_35ss1i8csfe";
const wrapper = "_35swdqebcv";
const arrowToFacit = "_35saebkirt";
const chevron = "_35scn3sk2c";
const container = "_35sc1e3j70w";
const label = "_35sl170017k";

export { arrowToFacit, chevron, container, label, root, scroller, wrapper };
import "./container.facit.style.linaria.module.css";
//# sourceMappingURL=container.facit.style.js.map
